import React from 'react';
import { Button, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface TemplateLoadDialogProps {
  visible: boolean;
  onAppend: () => void;
  onReplace: () => void;
  onCancel: () => void;
  /** Titles the prompt for a prior report instead of a template (same append/replace flow). */
  isPriorReport?: boolean;
}

const TemplateLoadDialog: React.FC<TemplateLoadDialogProps> = ({ visible, onAppend, onReplace, onCancel, isPriorReport = false }) => (
  <Modal
    open={visible}
    onCancel={onCancel}
    footer={[
      <Button key="append" type="primary" onClick={onAppend}>Append</Button>,
      <Button key="replace" danger onClick={onReplace}>Replace</Button>,
      <Button key="cancel" onClick={onCancel}>Cancel</Button>,
    ]}
  >
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: '0.5rem', fontSize: '1.25rem' }} />
      <b>{isPriorReport ? 'Load Prior Report' : 'Load Template'}</b>
    </div>
    <div style={{ marginTop: '0.75rem' }}>
      Do you want to replace the current content or append this
      {isPriorReport ? ' prior report' : ' template'}?
    </div>
    {isPriorReport && (
      <div style={{ marginTop: '0.5rem', color: '#666', fontSize: '12px' }}>
        Only the report text is copied — this study's header and the previous signature are not carried over.
      </div>
    )}
  </Modal>
);

export default TemplateLoadDialog;
